import React from 'react';
import './CustomButton.css';

const CustomButton = ({ 
  title, 
  onPress, 
  disabled = false, 
  variant = 'primary',
  size = 'medium',
  className = '',
  ...props 
}) => {
  const handleClick = (e) => {
    if (!disabled && onPress) {
      onPress(e);
    }
  };

  return (
    <button
      className={`custom-button ${variant} ${size} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {title}
    </button>
  );
};

export default CustomButton;